import React from "react";
import cn from "classnames";
import styles from "./Quality.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Happy Users",
    counter: "1m",
    images: "/images/content/user-green.svg",
    alt: "user",
    content:
      "We have a happy and intense community of users sharing their knowledge and learning new abilities every day",
  },
  {
    title: "Downloads",
    counter: "1.2m",
    images: "/images/content/electrical-plug.svg",
    alt: "electrical-plus",
    content:
      "More than 1m people have already downloaded our apps. What are you waiting for?",
  },
  {
    title: "Pro Trainers",
    counter: "50+",
    images: "/images/content/flag.svg",
    alt: "flag",
    content:
      "We have great teachers preparing new lessons for you every week. Join us!",
  },
  {
    title: "Lives and Counting",
    counter: "150+",
    images: "/images/content/youtube.svg",
    alt: "youtube",
    content:
      "We have new live streaming lessons every week! Don’t miss the next ones, download our app now!",
  },
];

const Quality = () => {
  return (
    <div className={cn("section-pb", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.list}>
          {items.map((x, index) => (
            <ScrollParallax className={styles.item} key={index}>
              <div className={styles.preview}>
                <img src={x.images} alt={x.alt} />
              </div>
              <div className={styles.counter}>{x.counter}</div>
              <div className={styles.title}>{x.title}</div>
              <div className={styles.content}>{x.content}</div>
            </ScrollParallax>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Quality;
